//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AcceptanceCriteriaStatus } from './enums/acceptance-criteria-status.enum';
import { AcceptanceCriteriaType } from './enums/acceptance-criteria-type.enum';
import { AutoMatchStrategy } from './enums/auto-match-strategy.enum';
import { CategoryLineOfBusinessEnum } from './enums/category-line-of-business-enum.enum';
import { DocumentTypeLevelType } from './enums/document-type-level-type.enum';
import { LineOfBusinessEnum } from './enums/line-of-business-enum.enum';
import { QmAssocCompleteStatus } from './enums/qm-assoc-complete-status.enum';
import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AssociationExpirationImplementationSettingsDto } from './models/association-expiration-implementation-settings-dto.model';
import { BulkAssignmentsRequestDto } from './models/bulk-assignments-request-dto.model';
import { ClientPortalVisibilitySettingsDto } from './models/client-portal-visibility-settings-dto.model';
import { ClientPortalVisibilityUpdateDto } from './models/client-portal-visibility-update-dto.model';
import { DocDueDateDto } from './models/doc-due-date-dto.model';
import { PagingTokenOfQmAssociationGridDto } from './models/paging-token-of-qm-association-grid-dto.model';
import { ProfileRequirementsDto } from './models/profile-requirements-dto.model';
import { QmAssociationAutoMatchSettingsViewModel } from './models/qm-association-auto-match-settings-view-model.model';
import { QmAssociationDto } from './models/qm-association-dto.model';
import { QmAssociationRequestDto } from './models/qm-association-request-dto.model';
import { QmAssociationWithClDto } from './models/qm-association-with-cl-dto.model';
import { UpdateExpirationImplementationSettingsDto } from './models/update-expiration-implementation-settings-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class QmAssociationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createQmAssociation(request: QmAssociationRequestDto): Observable<QmAssociationDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQmAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQmAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QmAssociationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QmAssociationDto>;
        }));
    }

    protected processCreateQmAssociation(response: HttpResponseBase): Observable<QmAssociationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QmAssociationDto;
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateQmAssociationName(id: number, request: QmAssociationRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQmAssociationName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQmAssociationName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateQmAssociationName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    lookupQmAssociations(lookUpParm: string | null | undefined): Observable<QmAssociationDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/lookup?";
        if (lookUpParm !== undefined && lookUpParm !== null)
            url_ += "lookUpParm=" + encodeURIComponent("" + lookUpParm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupQmAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupQmAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QmAssociationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QmAssociationDto[]>;
        }));
    }

    protected processLookupQmAssociations(response: HttpResponseBase): Observable<QmAssociationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QmAssociationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateQmAssociationAssignments(bulkAssignmentsRequestDto: BulkAssignmentsRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkAssignmentsRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQmAssociationAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQmAssociationAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateQmAssociationAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    qmAssociations(filter_Id: number | null | undefined, filter_Name: string | null | undefined, filter_ClName: string | null | undefined, filter_MappingStatus: QmAssocCompleteStatus[] | null | undefined, filter_AutoMatchStrategy: AutoMatchStrategy | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfQmAssociationGridDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations?";
        if (filter_Id !== undefined && filter_Id !== null)
            url_ += "Filter.Id=" + encodeURIComponent("" + filter_Id) + "&";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_ClName !== undefined && filter_ClName !== null)
            url_ += "Filter.ClName=" + encodeURIComponent("" + filter_ClName) + "&";
        if (filter_MappingStatus !== undefined && filter_MappingStatus !== null)
            filter_MappingStatus && filter_MappingStatus.forEach(item => { url_ += "Filter.MappingStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AutoMatchStrategy !== undefined && filter_AutoMatchStrategy !== null)
            url_ += "Filter.AutoMatchStrategy=" + encodeURIComponent("" + filter_AutoMatchStrategy) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQmAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQmAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfQmAssociationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfQmAssociationGridDto>;
        }));
    }

    protected processQmAssociations(response: HttpResponseBase): Observable<PagingTokenOfQmAssociationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfQmAssociationGridDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    qmAssociation(id: number): Observable<QmAssociationWithClDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQmAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQmAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QmAssociationWithClDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QmAssociationWithClDto>;
        }));
    }

    protected processQmAssociation(response: HttpResponseBase): Observable<QmAssociationWithClDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QmAssociationWithClDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQmAssociationRequirements(id: number, clobs: CategoryLineOfBusinessEnum[] | null | undefined, filter_RequirementId: number | null | undefined, filter_RequirementName: string | null | undefined, filter_TaskType: number[] | null | undefined, filter_ClientPortalVisibility: boolean | null | undefined, filter_RequirementLevel: DocumentTypeLevelType[] | null | undefined, filter_QualificationSettingsLevel: DocumentTypeLevelType[] | null | undefined, filter_LinesOfBusiness: number[] | null | undefined, filter_IsDefault: boolean | null | undefined, filter_ExpirationRequired: boolean | null | undefined, filter_RequirementDescription: DocumentTypeLevelType[] | null | undefined, filter_ExternalRequirementDescription: DocumentTypeLevelType[] | null | undefined, filter_CategoryLineOfBusinessId: number[] | null | undefined, filter_AcceptanceCriteriaType: AcceptanceCriteriaType[] | null | undefined, filter_AcceptanceCriteriaStatus: AcceptanceCriteriaStatus[] | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<ProfileRequirementsDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/requirements?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clobs !== undefined && clobs !== null)
            clobs && clobs.forEach(item => { url_ += "clobs=" + encodeURIComponent("" + item) + "&"; });
        if (filter_RequirementId !== undefined && filter_RequirementId !== null)
            url_ += "Filter.RequirementId=" + encodeURIComponent("" + filter_RequirementId) + "&";
        if (filter_RequirementName !== undefined && filter_RequirementName !== null)
            url_ += "Filter.RequirementName=" + encodeURIComponent("" + filter_RequirementName) + "&";
        if (filter_TaskType !== undefined && filter_TaskType !== null)
            filter_TaskType && filter_TaskType.forEach(item => { url_ += "Filter.TaskType=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ClientPortalVisibility !== undefined && filter_ClientPortalVisibility !== null)
            url_ += "Filter.ClientPortalVisibility=" + encodeURIComponent("" + filter_ClientPortalVisibility) + "&";
        if (filter_RequirementLevel !== undefined && filter_RequirementLevel !== null)
            filter_RequirementLevel && filter_RequirementLevel.forEach(item => { url_ += "Filter.RequirementLevel=" + encodeURIComponent("" + item) + "&"; });
        if (filter_QualificationSettingsLevel !== undefined && filter_QualificationSettingsLevel !== null)
            filter_QualificationSettingsLevel && filter_QualificationSettingsLevel.forEach(item => { url_ += "Filter.QualificationSettingsLevel=" + encodeURIComponent("" + item) + "&"; });
        if (filter_LinesOfBusiness !== undefined && filter_LinesOfBusiness !== null)
            filter_LinesOfBusiness && filter_LinesOfBusiness.forEach(item => { url_ += "Filter.LinesOfBusiness=" + encodeURIComponent("" + item) + "&"; });
        if (filter_IsDefault !== undefined && filter_IsDefault !== null)
            url_ += "Filter.IsDefault=" + encodeURIComponent("" + filter_IsDefault) + "&";
        if (filter_ExpirationRequired !== undefined && filter_ExpirationRequired !== null)
            url_ += "Filter.ExpirationRequired=" + encodeURIComponent("" + filter_ExpirationRequired) + "&";
        if (filter_RequirementDescription !== undefined && filter_RequirementDescription !== null)
            filter_RequirementDescription && filter_RequirementDescription.forEach(item => { url_ += "Filter.RequirementDescription=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ExternalRequirementDescription !== undefined && filter_ExternalRequirementDescription !== null)
            filter_ExternalRequirementDescription && filter_ExternalRequirementDescription.forEach(item => { url_ += "Filter.ExternalRequirementDescription=" + encodeURIComponent("" + item) + "&"; });
        if (filter_CategoryLineOfBusinessId !== undefined && filter_CategoryLineOfBusinessId !== null)
            filter_CategoryLineOfBusinessId && filter_CategoryLineOfBusinessId.forEach(item => { url_ += "Filter.CategoryLineOfBusinessId=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AcceptanceCriteriaType !== undefined && filter_AcceptanceCriteriaType !== null)
            filter_AcceptanceCriteriaType && filter_AcceptanceCriteriaType.forEach(item => { url_ += "Filter.AcceptanceCriteriaType=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AcceptanceCriteriaStatus !== undefined && filter_AcceptanceCriteriaStatus !== null)
            filter_AcceptanceCriteriaStatus && filter_AcceptanceCriteriaStatus.forEach(item => { url_ += "Filter.AcceptanceCriteriaStatus=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQmAssociationRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQmAssociationRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileRequirementsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileRequirementsDto[]>;
        }));
    }

    protected processGetQmAssociationRequirements(response: HttpResponseBase): Observable<ProfileRequirementsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileRequirementsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQmAssociationLineOfBusiness(id: number): Observable<LineOfBusinessEnum[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/lob";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQmAssociationLineOfBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQmAssociationLineOfBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LineOfBusinessEnum[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LineOfBusinessEnum[]>;
        }));
    }

    protected processGetQmAssociationLineOfBusiness(response: HttpResponseBase): Observable<LineOfBusinessEnum[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LineOfBusinessEnum[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientPortalNetworkVisibility(id: number): Observable<ClientPortalVisibilitySettingsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/client-portal-visibility";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPortalNetworkVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPortalNetworkVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientPortalVisibilitySettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientPortalVisibilitySettingsDto>;
        }));
    }

    protected processGetClientPortalNetworkVisibility(response: HttpResponseBase): Observable<ClientPortalVisibilitySettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientPortalVisibilitySettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateClientPortalNetworkVisibility(id: string, updates: ClientPortalVisibilityUpdateDto[]): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/client-portal-visibility";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateClientPortalNetworkVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateClientPortalNetworkVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateClientPortalNetworkVisibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocDueDate(id: number): Observable<DocDueDateDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/doc-due-date";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocDueDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocDueDateDto>;
        }));
    }

    protected processGetDocDueDate(response: HttpResponseBase): Observable<DocDueDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocDueDateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocDueDate(id: number, docDueDate: DocDueDateDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/doc-due-date";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(docDueDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDocDueDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCompleteStatus(id: number, isComplete: boolean): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/complete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isComplete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCompleteStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAutoMatchSettings(id: number): Observable<QmAssociationAutoMatchSettingsViewModel> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/automatch-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoMatchSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoMatchSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QmAssociationAutoMatchSettingsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QmAssociationAutoMatchSettingsViewModel>;
        }));
    }

    protected processGetAutoMatchSettings(response: HttpResponseBase): Observable<QmAssociationAutoMatchSettingsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QmAssociationAutoMatchSettingsViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAutoMatchSettings(settings: QmAssociationAutoMatchSettingsViewModel): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/automatch-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAutoMatchSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAutoMatchSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAutoMatchSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    containsApnDirectComplianceFacility(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/contains-apn-direct-compliance-facility";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContainsApnDirectComplianceFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContainsApnDirectComplianceFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processContainsApnDirectComplianceFacility(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExpirationImplementationSettings(id: number): Observable<AssociationExpirationImplementationSettingsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/expiration-implementation-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpirationImplementationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpirationImplementationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssociationExpirationImplementationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssociationExpirationImplementationSettingsDto>;
        }));
    }

    protected processGetExpirationImplementationSettings(response: HttpResponseBase): Observable<AssociationExpirationImplementationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssociationExpirationImplementationSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateExpirationImplementationSettings(id: number, settings: UpdateExpirationImplementationSettingsDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/qm-associations/{id}/expiration-implementation-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExpirationImplementationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExpirationImplementationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateExpirationImplementationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}